import { latexDeltaMarkdownAdapterMatch } from '@blocksuite/hive-inline-latex';
import { linkDeltaMarkdownAdapterMatch } from '@blocksuite/hive-inline-link';
import { referenceDeltaMarkdownAdapterMatch } from '@blocksuite/hive-inline-reference';
import type { ExtensionType } from '@blocksuite/store';

export const InlineDeltaToPlainTextAdapterExtensions: ExtensionType[] = [
  referenceDeltaMarkdownAdapterMatch,
  linkDeltaMarkdownAdapterMatch,
  latexDeltaMarkdownAdapterMatch,
];
